import { Canvas, util } from "fabric";
export function canvasExport() {
    function exportCanvasAsPNG(originalCanvas, jsonConfiguration, scaleFactor) {
        return new Promise((resolve) => {
            const exportCanvasElement = document.createElement('canvas');
            const clonedCanvas = new Canvas(exportCanvasElement, {
                width: originalCanvas.getWidth() * scaleFactor,
                height: originalCanvas.getHeight() * scaleFactor
            });
            new Canvas()
                .loadFromJSON(jsonConfiguration)
                .then((canvas) => {
                clonedCanvas.clear();
                document.fonts.ready.then(() => {
                    canvas.getObjects().forEach((obj) => {
                        obj.scaleX *= scaleFactor;
                        obj.scaleY *= scaleFactor;
                        obj.left *= scaleFactor;
                        obj.top *= scaleFactor;
                        obj.setCoords();
                        clonedCanvas.add(obj);
                    });
                    clonedCanvas.renderAll();
                    const canvasExport = util.toDataURL(clonedCanvas.getElement(), 'png', 1);
                    resolve(canvasExport);
                });
            });
        });
    }
    function exportCanvasWithoutJsonConfigAsPNG(originalCanvas, scaleFactor) {
        return new Promise((resolve) => {
            const exportCanvasElement = document.createElement('canvas');
            const clonedCanvas = new Canvas(exportCanvasElement, {
                width: originalCanvas.getWidth() * scaleFactor,
                height: originalCanvas.getHeight() * scaleFactor
            });
            clonedCanvas.clear();
            document.fonts.ready.then(() => {
                originalCanvas.getObjects().forEach((obj) => {
                    obj.scaleX *= scaleFactor;
                    obj.scaleY *= scaleFactor;
                    obj.left *= scaleFactor;
                    obj.top *= scaleFactor;
                    obj.setCoords();
                    clonedCanvas.add(obj);
                });
                clonedCanvas.renderAll();
                const canvasExport = util.toDataURL(clonedCanvas.getElement(), 'png', 1);
                resolve(canvasExport);
            });
        });
    }
    return {
        exportCanvasAsPNG,
        exportCanvasWithoutJsonConfigAsPNG
    };
}
